import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=305343d7&"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports